import icon1 from '../accets/icon-1.svg'
import icon2 from '../accets/icon-2.svg'
import icon3 from '../accets/icon-3.svg'
import icon4 from '../accets/icon-4.svg'


import profile1 from '../accets/profile-1.jpg'
import profile2 from '../accets/profile-2.jpg'
import profile3 from '../accets/profile-3.jpg'
import obada from '../accets/obada.jpg'
import bahaa from '../accets/bahaa.jpg'
import emad from '../accets/emad.jpg'
import tawfek from '../accets/tawfek.jpg'
export const ourServisec = [
    {
        src : icon1 ,
        heading : 'Acess your file anywhere',
        descption : 'The ability to use a smartphone, tablet, or computer to access your account means your files follow you everywhere.'
    },
    {
        src : icon2 ,
        heading : 'Security you can trust',
        descption : '2-factor authentication and user-controlled encryption are just a couple of the security we allow to help secure your files.'
    },
    {
        src : icon3,
        heading : 'Real-time collaboration',
        descption : 'Securely share files and folders whit friends, family and colleagues for live collaborationb, no email attachments required'
    },
    {
        src : icon4 ,
        heading : 'Store any type of file',
        descption : 'Wheter you are sharing holidays photos or work documents, fylo has you coverd alllowing for all file types to be securely stored and shared'
    },
]
export const ourTeam = [
    {
        note: 'Fylo has improved our team producivity by an order magnitude. Sincs making the switch our team has become a well-oiled collaboration machine',
        src : profile1,
        name: 'Satish Patel',
        job : 'founder & CEO , Huddle'
    },
    {
        note: 'Fylo has improved our team producivity by an order magnitude. Sincs making the switch our team has become a well-oiled collaboration machine',
        src : profile2,
        name: 'Bruce Mckenzie',
        job : 'founder & CEO , Huddle'
    },
    {
        note: 'Fylo has improved our team producivity by an order magnitude. Sincs making the switch our team has become a well-oiled collaboration machine',
        src : profile3,
        name: 'lva Boyd',
        job : 'founder & CEO , Huddle'
    },
    {
        note: 'Fylo has improved our team producivity by an order magnitude. Sincs making the switch our team has become a well-oiled collaboration machine',
        src : profile1,
        name: 'Bruce Mckenzie',
        job : 'founder & CEO , Huddle'
    },

]

export const ourClint = [
    {
        src : obada,
        name : 'obada-Kh',
        disc : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque, quam perferendis iste non asperiores quisquam ab odio quo facere placeat tempore quaerat numquam doloremque aspernatur mollitia amet quia? Accusantium, impedit.'
    },
    {
        src : tawfek,
        name : 'Tawfek-Kh',
        disc : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias, adipisci voluptates tempora quis modi quaerat deleniti quo autem quia deserunt.'
    },
    {
        src : bahaa,
        name : 'Bahaa-At',
        disc : 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Enim harum dicta vitae iure neque blanditiis dolorem quidem tenetur corporis fuga ipsa ad, sed magni fugiat laudantium, provident numquam! Delectus, molestias.'
    },
    {
        src : emad,
        name : 'Emad Al-Deen',
        disc : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque, quam perferendis iste non asperiores quisquam ab odio quo facere placeat tempore quaerat numquam doloremque aspernatur mollitia amet quia? Accusantium, impedit.'
    }
]

export const about = ["jobs" , "press" ,"Blog"]
export const contact = ["Terms" , "privacy"]

